import PropTypes from 'prop-types';
import classNames from 'classnames';

import { keyframes, legacyTheme } from '@prose-ui/legacy';
import { withStyles } from 'legacyStyles';

import { Button } from 'Components/LegacyButton';

import { SelectField } from './SelectField';

const scaleKeyframes = keyframes`
    0% { transform: scale(0); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
`;

const leaveKeyframes = keyframes`
    0% { width: 0; opacity: 0; }
    100% { width: 100%; opacity: 1; }
`;

const styles = {
  megaRoot: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    [legacyTheme.breakpoints.match('lg')]: {
      padding: 'inherit',
      justifyContent: 'space-between',
    },
  },
  root: {
    display: 'block',
    position: 'relative',
    padding: 0,
    width: 117,
    [legacyTheme.breakpoints.match('sm')]: {
      width: 80,
    },
  },
  wrapper: {
    position: '',
    height: 55,
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'stretch',
    alignItems: 'center',
  },
  quantityValue: {
    lineHeight: '22px',
    margin: '0 14px',
  },
  add: {
    // padding trick to align button text with select text
    padding: '2px 0 0 0',
    height: 'auto',
    width: 117,
    [legacyTheme.breakpoints.match('sm')]: {
      width: 80,
    },
  },
  addAnimation: {
    animation: `${leaveKeyframes} .3s`,
  },
  quantityAnimation: {
    animation: `${scaleKeyframes} .3s`,
  },
  selectLabel: {
    display: 'none',
  },
};

const QuantitySelector = ({
  classes,
  className,
  disabled,
  isLoading,
  quantity,
  minQuantity,
  maxQuantity,
  onSetQuantityProduct,
  slug,
}) => {
  return (
    <div className={classes.megaRoot}>
      <div
        className={classNames(classes.root, {
          [classes.add]: quantity === 0,
        })}
        data-testid={disabled ? '' : `${slug}-quantity-selector`}
        id={slug}
      >
        {quantity ? (
          <div className={classNames(classes.quantityAnimation, className)}>
            <SelectField
              aria-label="Please select a quantity"
              data-click="quantity"
              data-from={`${slug}-card`}
              hiddenLabel
              id={`${slug}-select`}
              label="Please select a quantity"
              list={[...Array(maxQuantity - minQuantity + 1)]
                .map((_e, i) => i + minQuantity)
                .map(v => v.toString())}
              onChange={e => onSetQuantityProduct(parseInt(e.target.value, 10))}
              value={quantity.toString()}
            />
          </div>
        ) : (
          <div className={classes.addAnimation}>
            <Button
              data-click="add"
              data-from={`${slug}-card`}
              disabled={disabled}
              isLoading={isLoading}
              onClick={() => onSetQuantityProduct(1)}
              variant="add"
            >
              ADD
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

QuantitySelector.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  quantity: PropTypes.number,
  minQuantity: PropTypes.number,
  maxQuantity: PropTypes.number,
  onSetQuantityProduct: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

QuantitySelector.defaultProps = {
  className: '',
  quantity: 1,
  minQuantity: 0,
  maxQuantity: 6,
  disabled: false,
  isLoading: false,
};

export default withStyles(QuantitySelector, styles);
